import apiWrapper from 'Helpers/apiWrapper'
import extractApiData from 'Helpers/extractApiData'
import { encodeParams } from 'mailup-react-helpers'

const endpoints = ((baseURL) => {
  return {
    //  Anagraphic fields
    getDynamicFieldsDefinition: `${baseURL}/api/fields`,
    //  Groups
    getListOfGroupDetails: (idList, params) =>
      `${baseURL}/api/list/${encodeURIComponent(idList)}/groups?${encodeParams(
        params
      )}`,
    addGroup: `${baseURL}/api/groups`,
    getGroupById: (idGroup) =>
      `${baseURL}/api/groups/${encodeURIComponent(idGroup)}`,
    getGroupDetails: (idGroup) =>
      `${baseURL}/api/groups/${encodeURIComponent(idGroup)}`,
    getRecipients: (idList, searchParams) =>
      `${baseURL}/api/list/${encodeURIComponent(idList)}/search?${encodeParams(
        searchParams
      )}`
  }
})(process.env.BERECIPIENT_URL)

/**
 * @description Get account dynamic fields
 */
export const beRecipientGetDynamicFieldsDefinition = () => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getDynamicFieldsDefinition
  }).then(({ data }) => data)
}

/**
 *
 * @param {number} idList ID of list
 * @param {Object} params
 * @param {('STARTWITH'|'ENDWITH'|'CONTAINS'|'EQUALTO')} params.searchType Value of search type
 * @param {string} params.searchBy Value to search for
 * @param {('HASEMAILRECIPIENTS'|'HASSMSRECIPIENTS'|'HASRECIPIENTS')} params.hasRecipients filter non empty group
 * @param {('Normal'|'Test'|'SubscriptionForm'|'AutoprofileForm'|'SocialPlus'|'Temporary')} params.groupType type of the group to search for
 * @param {number} params.pageSize Number of sources returned
 * @param {number} params.pageNumber Page number
 * @param {string} params.orderBy Order by specified field
 * @param {boolean} params.orderDescending Order descending
 *
 */
export const beRecipientGetListOfGroupDetails = (idList, params) => {
  const url = endpoints.getListOfGroupDetails(idList, params)
  return apiWrapper({
    method: 'get',
    url
  }).then(({ data }) => data)
}

export const beRecipientAddGroup = (payload) => {
  const url = endpoints.addGroup
  return apiWrapper({
    method: 'post',
    url,
    data: JSON.stringify(payload)
  }).then(({ data }) => data)
}

export const beRecipientGetGroupById = (idGroup) => {
  const url = endpoints.getGroupById(idGroup)
  return apiWrapper({
    method: 'get',
    url
  }).then(({ data }) => data)
}

export const beRecipientGetGroupDetails = (idGroup) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getGroupDetails(idGroup)
  }).then(extractApiData)
}

export const beRecipientApiSearchForRecipients = (
  idList,
  searchParams,
  searchConditions
) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.getRecipients(idList, searchParams),
    data: JSON.stringify(searchConditions),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(extractApiData)
}

export const GROUPS_SEARCH_TYPE_EQUALTO = 'EQUALTO'
export const GROUPS_SEARCH_TYPE_CONTAINS = 'CONTAINS'
export const CHANNEL_TYPE_EMAIL = 'Email'
export const SUBSCRIPTION_TYPE_SUBSCRIBED = 'Subscribed'
export const GROUPS_SEARCH_TYPE_ECONTAINS = 'CONTAINS'
export const HAS_RECIPIENTS = 'HASRECIPIENTS'
export const HAS_EMAIL_RECIPIENTS = 'HASEMAILRECIPIENTS'
export const HAS_SMS_RECIPIENTS = 'HASSMSRECIPIENTS'
export const GROUP_TYPE_TEST = 'Test'
